import React from "react";
import MainStore from "../stores/MainStore";

const PointCounterDescription = () => {
  const { player } = MainStore();
  const points = [
    { description: "open", value: player?.points?.open },
    { description: "donated", value: player?.points?.donated },
    { description: "earned", value: player?.points?.earned },
    { description: "given", value: player?.points?.given },
  ];
  return (
    <div
      className="divColumn"
      style={{
        backgroundColor: "#2f2f2f",
        border: "1px solid grey",
        padding: "5px",
        borderRadius: ".5rem/.5rem",
      }}
    >
      {points.map((p, index) => (
        <PointHolder
          index={index}
          description={p.description}
          value={p.value}
          key={p.description}
        />
      ))}
    </div>
  );
};

const PointHolder = ({ description, value, index }) => {
  return (
    <div
      className="divColumn"
      style={{
        marginTop: "2px",
        backgroundColor: index % 2 ? "#4f4f4f" : null,
        width: "100%",
        height: "100%",
        padding: "3px",
      }}
    >
      <img src={"/icons/icon_point.png"} className="icon25" />
      <div className="textBoldWhite">{value}</div>
      <div className="textWhite">{description}</div>
    </div>
  );
};

export default PointCounterDescription;
